interface CloudflareImageOptions {
  fit?: 'crop' | 'scale-down' | 'squeeze';
  width?: number;
  height?: number;
  format?: 'auto' | 'avif' | 'webp' | 'json';
}

export const buildCloudflareImageUrl = (
  imageUrl: string,
  {
    fit = 'scale-down',
    width,
    height,
    format = 'auto',
  }: CloudflareImageOptions = {},
) => {
  if (!imageUrl) {
    return '';
  }

  if (imageUrl.includes('/cdn-cgi/image/')) {
    return imageUrl;
  }

  if (window.location.hostname.startsWith('local')) {
    return imageUrl;
  }

  const options = [
    fit ? `fit=${fit}` : null,
    width ? `width=${width}` : null,
    height ? `height=${height}` : null,
    'q=75',
    format ? `f=${format}` : null,
  ].filter(Boolean);

  if (options.length === 0) {
    return imageUrl;
  }

  return `/cdn-cgi/image/${options.join(',')}/${imageUrl.replace(/^\//, '')}`;
};
